module.exports = __webpack_public_path__ + "img/temp1.80aa2a2c.jpeg";